import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import type { Person } from '@vigeo/shared';
import { PortalLinkButton, PortalLinkDialog, usePortalLinkHandOver, type PortalLinkHandOver } from '@/features/people';

/**
 * Giving the candidate the link and the code by hand, from the offer screens (#458; N5 built to the pop-up guardrails, #501).
 *
 * The behaviour lives in `features/people/PortalLinkDialog.tsx`, because it is one dialog on every screen (PG5); this file is
 * only the offer screens' names for it. The words, the order and the protections are the ones #460 and #481 settled, and
 * `tests/offer-qa-fixes.test.tsx` still pins them. Nothing is persisted: not in browser storage and not in the react-query
 * cache (N1 there pins it). The one-time values live only in the per-person store, and go when "Done, hide them" is pressed
 * or the screen goes away.
 */
export const useHandOverLink = (person: Person, askFirst: boolean): PortalLinkHandOver => usePortalLinkHandOver(person, askFirst);
export { PortalLinkButton as HandOverLinkButton, PortalLinkDialog as HandOverLinkDialog };

/**
 * The failure beside a placement that makes the link at once (the not-emailed notice, which sits directly above its button).
 * A link that was made shows in the shared dialog; only a failure has nowhere else to go.
 */
export function HandOverLinkError({ handOver }: { readonly handOver: PortalLinkHandOver }) {
  if (handOver.errorMessage === null || handOver.askFirst) return null;
  return <MessageBar intent="error"><MessageBarBody>{handOver.errorMessage}</MessageBarBody></MessageBar>;
}
